'use client';

import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

const FrequentQuestions = () => {
  const t = useTranslations();

  return (
    <section>
      <LayoutGrid className="pt-20">
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <Typography
            Element="h6"
            variant="unset"
            className="mb-14 text-center text-[26px] leading-[31px] md:text-[40px] md:leading-[48px]"
          >
            {t('extend_section_header_13')}
          </Typography>
        </GridItem>
      </LayoutGrid>
      <LayoutGrid className="pb-20">
        <GridItem
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main' }}
          className="flex flex-col gap-10 lg:flex-row lg:gap-16"
        >
          <div className="flex flex-1 flex-col">
            <Typography className="pb-3.5 text-2xl">
              {t('extend_section_header_14')}
            </Typography>
            <Typography>{t('extend_section_header_15')}</Typography>
          </div>
          <div className="flex flex-1 flex-col">
            <Typography className="pb-3.5 text-2xl">
              {t('extend_section_header_16')}
            </Typography>
            <Typography>{t('extend_section_header_17')}</Typography>
          </div>
          <div className="flex flex-1 flex-col">
            <Typography className="pb-3.5 text-2xl">
              {t('extend_section_header_18')}
            </Typography>
            <Typography>{t('extend_section_header_19')}</Typography>
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default FrequentQuestions;
